import React, { useState } from 'react';
import { FC } from 'react';
import { uploadHistoryModel } from '../../APIs/userApi';
import { useTenant } from '../../contexts/TenantContext';
import { Button } from '../atomic/buttons';
import { downloadText } from '../../utils/download';

type Prop = {
    activity: uploadHistoryModel[] | undefined;
    year: string | undefined;
    month: string | undefined;
};
export const DownloadUploadActivityLog: FC<Prop> = (props) => {
    const { activity, year, month } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const { getTenantUser } = useTenant();

    const download = async () => {
        setLoading(true);

        const csvData = activity
            ? activity.map((r) => {
                  const user = getTenantUser(r.userId);
                  const userName = user
                      ? `${user.familyName} ${user.givenName}`
                      : 'unknown';
                  const row = [r.date, userName, r.mimeType, r.count, r.size];

                  return row;
              })
            : [];
        const header = [
            '日付',
            'ユーザ',
            'ファイル種別',
            'ファイル数',
            'サイズ',
        ];

        csvData.unshift(header);
        const csvContent =
            '\ufeff' +
            csvData
                .map((row) => {
                    return row
                        .map((col) => {
                            return (
                                '"' +
                                (typeof col == 'string'
                                    ? col.replace(/\"/g, '""')
                                    : col) +
                                '"'
                            );
                        })
                        .join(',');
                })
                .join('\n');

        downloadText(
            `upload_log_${year}年${month}月.csv`,
            csvContent,
            'text/csv'
        );
        setLoading(false);
    };

    return (
        <div className="downloadList">
            <Button onClick={() => download()} disabled={loading}>
                ダウンロード
            </Button>
        </div>
    );
};
